var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'grid-template-rows': `${_vm.centralHeight}`}),attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"content"}},[_c('router-view',{on:{"requestLogin":() => _vm.$emit('requestLogin'),"showCdss":(patientData) => _vm.$emit('showCdss', patientData)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }